<template>
  <div>
    <el-form ref="form" :model="formData" size="small">
      <el-row :gutter="10">
        <el-col :span="8">
          <el-form-item
            :label="
              $l('INDEX.form_label_production_order_goods_no') || '产品编号'
            "
          >
            <el-input v-model="formData.orderGoodsNo" readonly> </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="16">
          <el-form-item
            :label="
              $l('INDEX.form_label_production_order_identify_goods_no') ||
                '产品识别编号'
            "
          >
            <el-input v-model="formData.identifyGoodsNo" readonly> </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="12">
          <el-form-item
            :label="
              $l('INDEX.form_label_production_order_goods_name') || '产品名称'
            "
          >
            <el-input v-model="formData.orderGoodsName" readonly> </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            :label="
              $l('INDEX.form_label_production_order_goods_name_en') ||
                '产品英文名称'
            "
          >
            <el-input v-model="formData.orderGoodsNameEn" readonly> </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="6">
          <el-form-item
            :label="
              $l('INDEX.form_label_production_order_goods_master_category') ||
                '主分类'
            "
          >
            <el-input v-model="formData.masterCategoryName" readonly>
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="
              $l('INDEX.form_label_production_order_goods_detail_category') ||
                '明细分类'
            "
          >
            <el-input v-model="formData.categoryName" readonly> </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="
              $l('INDEX.form_label_production_order_goods_pattern') || '花型'
            "
          >
            <el-input v-model="formData.orderGoodsPattern" readonly> </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="
              $l('INDEX.form_label_production_order_goods_pattern_en') ||
                '花型英文名称'
            "
          >
            <el-input v-model="formData.orderGoodsPatternEn" readonly>
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="6">
          <el-form-item
            :label="
              $l('INDEX.form_label_production_order_goods_color') || '产品颜色'
            "
          >
            <el-input v-model="formData.orderGoodsColor" readonly> </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="
              $l('INDEX.form_label_production_order_goods_color_en') ||
                '英文颜色'
            "
          >
            <el-input v-model="formData.orderGoodsColorEn" readonly> </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="
              $l('INDEX.form_label_production_order_goods_unit') || '产品单位'
            "
          >
            <el-input v-model="formData.v_orderGoodsUnit" readonly> </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="
              $l('INDEX.form_label_production_order_goods_english_size') ||
                '英文尺寸'
            "
          >
            <el-input v-model="formData.v_englishSize" readonly> </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="6">
          <el-form-item
            :label="$l('INDEX.form_label_production_order_goods_qty') || '数量'"
          >
            <el-input v-model="formData.qty" readonly> </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="
              `${$l('INDEX.form_label_production_order_goods_price') ||
                '成本价'}${
                formData.v_currencyUnit ? `(${formData.v_currencyUnit})` : ''
              }`
            "
          >
            <el-input v-model="formData.price" readonly> </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="
              $l('INDEX.form_label_production_order_goods_is_group') ||
                '是否套装'
            "
          >
            <el-input v-model="formData.v_isGroup" readonly> </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="
              $l('INDEX.form_label_production_order_goods_in_package_qty') ||
                '装箱入数'
            "
          >
            <el-input v-model="formData.inPackageQty" readonly> </el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>
<script>
export default {
  props: { orderGoodsCode: { type: String, default: '' } },
  data() {
    return {
      formData: {},
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    getData() {
      if (!this.orderGoodsCode) return
      this.$api
        .pendingOrderGoodsDetailApi({ orderGoodsCode: this.orderGoodsCode })
        .then((res) => {
          this.formData = res.body
        })
    },
  },
}
</script>
